<form [formGroup]="form" (submit)="$event.preventDefault()">
  <ng-template #verificationField>
    <div class="row">
      <div class="col-sm-12">
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["validatonVerificationComment"]}}
            <span *ngIf="isRequired('validatonVerificationComment')" class="required"></span>
          </label>

          <div class="full-width">
            <div class="control-col">
              <angular-editor [id]="'validatonVerificationComment'" formControlName="validatonVerificationComment"
                [config]="configValidation"></angular-editor>
              <mat-error *ngIf="getErrorMessage('validatonVerificationComment') as errorMessage">{{ errorMessage }}</mat-error>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  @if (displayVerificationField()) {
  <mat-card class="verification-card" style="box-shadow: none;">
    <mat-card-content class="container-fluid">
      <ng-container [ngTemplateOutlet]="verificationField"></ng-container>
    </mat-card-content>
  </mat-card>
  }

  <mat-card style="box-shadow: none;">
    <mat-card-content class="container-fluid">
      <div class="row">
        <mat-card-title class="section-title">
          Execution Tracker
        </mat-card-title>
        <br>
        <div class="col-sm-12">
          <div class="horizontal-form-field">
            <label class="form-label">Resolution Target Date</label>
            <mat-form-field class="full-width">
              <input matInput [value]="resolutionTargetDate() | date:'dd MMMM yyyy' " readonly
                placeholder="Resolution Target Date">
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card style="box-shadow: none;">
    <mat-card-content class="container-fluid">
      <div class="row">
        <mat-card-title class="section-title">
          Mitigation & Resolution Strategies
        </mat-card-title>
        <br>
        <div class="row">
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["mitigationPlanEn"]}}</label>
              <div class="full-width">
                <div class="control-col">
                  <angular-editor [id]="'mitigationPlanEn'" formControlName="mitigationPlanEn"
                    [config]="configMitigationEn"></angular-editor>
                  <mat-error *ngIf="getErrorMessage('mitigationPlanEn') as errorMessage">{{ errorMessage }}</mat-error>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">
                {{displayNames["resolutionPlanEn"]}}
                @if (!form.get('resolutionPlanEn')?.disabled) {
                <span class="required"></span>
                }
              </label>
              <div class="full-width">
                <div class="control-col">
                  <angular-editor [id]="'resolutionPlanEn'" formControlName="resolutionPlanEn"
                    [config]="configResolutionEn"></angular-editor>
                  <mat-error *ngIf="getErrorMessage('resolutionPlanEn') as errorMessage">{{ errorMessage
                    }}</mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["mitigationPlanRu"]}}</label>
              <div class="full-width">
                <div class="control-col">
                  <angular-editor [id]="'mitigationPlanRu'" formControlName="mitigationPlanRu"
                    [config]="configMitigationRu"></angular-editor>
                  <mat-error *ngIf="getErrorMessage('mitigationPlanRu') as errorMessage">{{ errorMessage }}</mat-error>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["resolutionPlanRu"]}}</label>
              <div class="full-width">
                <div class="control-col">
                  <angular-editor [id]="'resolutionPlanRu'" formControlName="resolutionPlanRu"
                    [config]="configResolutionRu"></angular-editor>
                  <mat-error *ngIf="getErrorMessage('resolutionPlanRu') as errorMessage">{{ errorMessage }}</mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["mitigationPlanKz"]}}</label>
              <div class="full-width">
                <div class="control-col">
                  <angular-editor [id]="'mitigationPlanKz'" formControlName="mitigationPlanKz"
                    [config]="configMitigationKz"></angular-editor>
                  <mat-error *ngIf="getErrorMessage('mitigationPlanKz') as errorMessage">{{ errorMessage }}</mat-error>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["resolutionPlanKz"]}}</label>
              <div class="full-width">
                <div class="control-col">
                  <angular-editor [id]="'resolutionPlanKz'" formControlName="resolutionPlanKz"
                    [config]="configResolutionKz"></angular-editor>
                  <mat-error *ngIf="getErrorMessage('resolutionPlanKz') as errorMessage">{{ errorMessage }}</mat-error>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card style=" box-shadow: none;">
    <mat-card-content class="container-fluid">
      <mat-card-title class="section-title">
        Action Items
        <span class="required"></span>
        <!-- @if (aiId?.value && !form.get('resolutionPlanEn')?.disabled) {
        } -->
      </mat-card-title>
      <div class="container-fluid">
        <div class="action-item-controls">
          <button mat-button type="button" color="primary" (click)="addActionItem()"
            [disabled]="!(canEdit$ | async)">
            <mat-icon svgIcon="plus"></mat-icon>
            Add Action Item
          </button>
          <button mat-button id="removeSelectedActionItemBtn" type="button" color="primary" (click)="removeActionItem()"
            *ngIf="dataSource.data.length > 0 && selection.hasValue()" [disabled]="!(canEdit$ | async)">
            Remove</button>
        </div>
      </div>

      <div class="table-container">
        <div class="table-scroll-wrapper">
          <table mat-table [dataSource]="dataSource" matSort class="report-table">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()" aria-label="Select all"></mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)" aria-label="Select row"></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="actionItemId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                ID
                <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemId')" (filterChange)="applyFilter($event, 'actionItemId')" />
              </th>
              <td mat-cell *matCellDef="let item">{{ item.actionItemId }}</td>
            </ng-container>

            <ng-container matColumnDef="actionItemDescriptionEn">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Description [EN]
                <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemDescriptionEn')" (filterChange)="applyFilter($event, 'actionItemDescriptionEn')" />
              </th>
              <td mat-cell *matCellDef="let item" class="description-cell">{{ item.actionItemDescriptionEn | stripHtml
                }}</td>
            </ng-container>

            <ng-container matColumnDef="actionItemDescriptionRu">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Description [RU]
                <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemDescriptionRu')" (filterChange)="applyFilter($event, 'actionItemDescriptionRu')" />
              </th>
              <td mat-cell *matCellDef="let item" class="description-cell">{{ item.actionItemDescriptionRu | stripHtml
                }}</td>
            </ng-container>

            <ng-container matColumnDef="actionItemDescriptionKz">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Description [KZ]
                <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemDescriptionKz')" (filterChange)="applyFilter($event, 'actionItemDescriptionKz')" />
              </th>
              <td mat-cell *matCellDef="let item" class="description-cell">{{ item.actionItemDescriptionKz | stripHtml
                }}</td>
            </ng-container>

            <ng-container matColumnDef="actionItemOwner">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Action Item Owner
                <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemOwner')" (filterChange)="applyFilter($event, 'actionItemOwner')" />
              </th>
              <td mat-cell *matCellDef="let item">{{ item.actionItemOwner }}</td>
            </ng-container>

            <ng-container matColumnDef="dueDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Due Date
                <app-table-column-filter class="column-filter" [class.active]="isActive('dueDate')" (filterChange)="applyFilter($event, 'dueDate')" />
              </th>
              <td mat-cell *matCellDef="let item">{{ item.dueDate | date:'dd MMMM yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Status
                <app-table-column-filter class="column-filter" [class.active]="isActive('status')" (filterChange)="applyFilter($event, 'status')" />
              </th>
              <td mat-cell *matCellDef="let item">{{ item.status }}</td>
            </ng-container>
            <ng-container matColumnDef="completedOn">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Completed On
                <app-table-column-filter class="column-filter" [class.active]="isActive('completedOn')" (filterChange)="applyFilter($event, 'completedOn')" />
              </th>
              <td mat-cell *matCellDef="let item">{{ item.completedOn | date:'dd MMMM yyyy' }}</td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="editActionItem(row.id)"
              [class.selected]="selection.isSelected(row)"></tr>

          </table>
        </div>
      </div>
      <br>
      <br>
      <br>
    </mat-card-content>
  </mat-card>
</form>
